"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHURN_RETENTION_LOAN_TERM_TOLERANCE_MONTHS = exports.CHURN_RETENTION_TREATMENT_TERMINATED_STATUSES = exports.CHURN_RETENTION_TREATMENT_ACTIVE_STATUSES = exports.ChurnRetentionTreatmentStatus = exports.CHURN_RETENTION_TERMINATED_STATUSES = exports.CHURN_RETENTION_ACTIVE_STATUSES = exports.ChurnRetentionStatus = exports.FullReUnderwriteProductType = exports.ChurnRetentionTreatmentType = void 0;
/**  @TranslateToPython @TranslateToEnum  */
var ChurnRetentionTreatmentType;
(function (ChurnRetentionTreatmentType) {
    ChurnRetentionTreatmentType["CLI"] = "CLI";
    ChurnRetentionTreatmentType["APR_REDUCTION"] = "APR_REDUCTION";
    ChurnRetentionTreatmentType["CLI_AND_APR_REDUCTION"] = "CLI_AND_APR_REDUCTION";
    ChurnRetentionTreatmentType["CLI_AND_APR_REDUCTION_AND_BALANCE_SWEEP"] = "CLI_AND_APR_REDUCTION_AND_BALANCE_SWEEP";
    ChurnRetentionTreatmentType["MORTGAGE_BROKERING"] = "MORTGAGE_BROKERING";
    ChurnRetentionTreatmentType["FIXED_TERM_INSTALLMENT_PLAN"] = "FIXED_TERM_INSTALLMENT_PLAN";
    ChurnRetentionTreatmentType["DEFENSIVE_FIXED_MORTGAGE_PLAN"] = "DEFENSIVE_FIXED_MORTGAGE_PLAN";
    ChurnRetentionTreatmentType["FULL_BALANCE_SWEEP_WITH_FEE"] = "FULL_BALANCE_SWEEP_WITH_FEE";
    ChurnRetentionTreatmentType["CLI_THEN_BALANCE_SWEEP_FULL_LINE"] = "CLI_THEN_BALANCE_SWEEP_FULL_LINE";
})(ChurnRetentionTreatmentType || (exports.ChurnRetentionTreatmentType = ChurnRetentionTreatmentType = {}));
/**  @TranslateToPython @TranslateToEnum  */
var FullReUnderwriteProductType;
(function (FullReUnderwriteProductType) {
    FullReUnderwriteProductType["DEFAULT"] = "DEFAULT";
    FullReUnderwriteProductType["DEFENSIVE_FMP"] = "DEFENSIVE_FMP";
    FullReUnderwriteProductType["MOFO"] = "MOFO";
    FullReUnderwriteProductType["CLI_THEN_BALANCE_SWEEP_FULL_LINE"] = "CLI_THEN_BALANCE_SWEEP_FULL_LINE";
})(FullReUnderwriteProductType || (exports.FullReUnderwriteProductType = FullReUnderwriteProductType = {}));
/**  @TranslateToPython @TranslateToEnum  */
var ChurnRetentionStatus;
(function (ChurnRetentionStatus) {
    ChurnRetentionStatus["initiated"] = "initiated";
    ChurnRetentionStatus["inProgress"] = "inProgress";
    ChurnRetentionStatus["approvedNotApplied"] = "approvedNotApplied";
    ChurnRetentionStatus["succeeded"] = "succeeded";
    ChurnRetentionStatus["failed"] = "failed";
    ChurnRetentionStatus["expired"] = "expired";
    ChurnRetentionStatus["canceled"] = "canceled";
})(ChurnRetentionStatus || (exports.ChurnRetentionStatus = ChurnRetentionStatus = {}));
/**  @TranslateToPython  */
exports.CHURN_RETENTION_ACTIVE_STATUSES = [ChurnRetentionStatus.initiated, ChurnRetentionStatus.inProgress, ChurnRetentionStatus.approvedNotApplied];
exports.CHURN_RETENTION_TERMINATED_STATUSES = [ChurnRetentionStatus.succeeded, ChurnRetentionStatus.failed, ChurnRetentionStatus.expired, ChurnRetentionStatus.canceled];
/**  @TranslateToPython @TranslateToEnum  */
var ChurnRetentionTreatmentStatus;
(function (ChurnRetentionTreatmentStatus) {
    ChurnRetentionTreatmentStatus["dryrunFailed"] = "dryrunFailed";
    ChurnRetentionTreatmentStatus["inProgress"] = "inProgress";
    ChurnRetentionTreatmentStatus["succeed"] = "succeed";
    ChurnRetentionTreatmentStatus["failed"] = "failed";
    ChurnRetentionTreatmentStatus["initiated"] = "initiated";
    ChurnRetentionTreatmentStatus["canceled"] = "canceled";
})(ChurnRetentionTreatmentStatus || (exports.ChurnRetentionTreatmentStatus = ChurnRetentionTreatmentStatus = {}));
/**  @TranslateToPython  */
exports.CHURN_RETENTION_TREATMENT_ACTIVE_STATUSES = [ChurnRetentionTreatmentStatus.inProgress, ChurnRetentionTreatmentStatus.initiated];
exports.CHURN_RETENTION_TREATMENT_TERMINATED_STATUSES = [
    ChurnRetentionTreatmentStatus.succeed,
    ChurnRetentionTreatmentStatus.failed,
    ChurnRetentionTreatmentStatus.dryrunFailed,
    ChurnRetentionTreatmentStatus.canceled,
];
/**
 * Maximum allowed difference (in months) between the applied loan term and the planned/offered loan term
 * when applying churn retention balance sweep benefits.
 *
 * This tolerance accounts for:
 * - Minor variations in timing when the balance sweep is executed vs when the offer was generated
 *
 * The applied loan term must be within [plannedTerm - CHURN_RETENTION_LOAN_TERM_TOLERANCE_MONTHS, plannedTerm]
 * to be considered valid and avoid triggering alerts.
 *
 * @TranslateToPython
 */
exports.CHURN_RETENTION_LOAN_TERM_TOLERANCE_MONTHS = 2;
